<script setup lang="ts">
defineProps<{
  currentPage: number
  totalRows: number
  perPage: number
  lastPage: number
}>()

const emit = defineEmits(["page-change", "per-page-change"])
</script>

<template>
  <b-container v-if="totalRows > 0" fluid class="px-0">
    <b-row>
      <b-col md="6">
        <b-pagination
          :value="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          @input="emit('page-change', $event)"
        />
        {{ totalRows }} total. Page {{ currentPage }} of {{ lastPage }}
      </b-col>
      <b-col md="6" class="text-right">
        Show
        <b-select
          :value="perPage"
          style="max-width: 6em; display: inline-block; width: auto"
          @input="emit('per-page-change', $event)"
        >
          <option :value="100">100</option>
          <option :value="500">500</option>
          <option :value="1000">1000</option>
        </b-select>
        per page
      </b-col>
    </b-row>
  </b-container>
</template>
